module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_5-794a42a70b727f6595e0b00ceb341750.png";